import { useTranslation } from 'react-i18next';

import dayjs, { Dayjs } from 'dayjs';

type TRangePreset = {
  label: string;
  value: [Dayjs, Dayjs];
};

export const useDateRangePresets = (): TRangePreset[] => {
  const { t } = useTranslation();

  return [
    {
      label: t('rangePicker.today'),
      value: [dayjs().startOf('day'), dayjs().endOf('day')],
    },
    {
      label: t('rangePicker.yesterday'),
      value: [
        dayjs().subtract(1, 'day').startOf('day'),
        dayjs().subtract(1, 'day').endOf('day'),
      ],
    },
    {
      label: t('rangePicker.currentWeek'),
      value: [dayjs().startOf('week'), dayjs().endOf('week')],
    },
    {
      label: t('rangePicker.lastWeek'),
      value: [
        dayjs().subtract(1, 'week').startOf('week'),
        dayjs().subtract(1, 'week').endOf('week'),
      ],
    },
    {
      label: t('rangePicker.currentMonth'),
      value: [dayjs().startOf('month'), dayjs().endOf('month')],
    },
    {
      label: t('rangePicker.lastMonth'),
      value: [
        dayjs().subtract(1, 'month').startOf('month'),
        dayjs().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      label: t('rangePicker.currentYear'),
      value: [dayjs().startOf('year'), dayjs().endOf('year')],
    },
    {
      label: t('rangePicker.lastYear'),
      value: [
        dayjs().subtract(1, 'year').startOf('year'),
        dayjs().subtract(1, 'year').endOf('year'),
      ],
    },
  ];
};
